<template>
  <div class="btn-group btn-group-sm rounded-pill overflow-hidden">
    <button type="button" class="btn border-0 btn-light" :class="{ 'bg-white': white }" @click="quantity--">
        <i data-feather="minus" width="16"></i>
    </button>
    <input type="text" class="form-control rounded-0 text-center border-0"
    :class="[ white ? 'bg-white' : 'bg-light' ]" name="quantity" v-model="quantity">
    <button type="button" class="btn border-0 btn-light" :class="{ 'bg-white': white }" @click="quantity++">
        <i data-feather="plus" width="16"></i>
    </button>
  </div>
</template>

<script>
import feather from 'feather-icons';

export default {
  props: {
    value: Number,
    white: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    quantity: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', Math.max(val, 1));
      }
    }
  },

  mounted() {
    feather.replace();
  }
}
</script>
